import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { LocationIcon, PhoneIcon } from '../../../components/icons'
import { Box, Button, Flex, Stack, Text, useDisclosure } from '../../../vanilla'
import { OrderAddress } from '../../../types/store/basket'
import { capitalize } from '../../../utils/utils'
import { AddOrEditCustomerAddressModal } from '../../account/partials/account-addresses/partials/add-or-edit-customer-address-modal'

interface YourDeliverySelectedAddressProps {
  onEditAddressClick?: () => void
  selectedAddress?: OrderAddress
  setSelectedAddressId?: (id: string | null) => void
  selectedAddressId?: string | null
  preBook?: boolean
}

export const YourDeliverySelectedAddress = observer((props: YourDeliverySelectedAddressProps) => {
  const {selectedAddress, preBook} = props
  const {fullName, title, addressId, phone, address1, address2, stateCode, city, postalCode} = (selectedAddress || {}) as OrderAddress
  const addressModal = useDisclosure()
  const [selectedAddressId, setSelectedAddressId] = useState<string | null>(null)
  function displayAddress() {
    return [address1, address2, stateCode, city, postalCode].filter(Boolean).join(', ')
  }

  const onEditAddress = (id: string) => {
    setSelectedAddressId(id)
    addressModal.onOpen()
  }
  const onSubmitAddressModalForm = () => {
    addressModal.onClose()
    setSelectedAddressId(null)
  }
  const onDismissAddressModalForm = () => {
    addressModal.onClose()
    setSelectedAddressId(null)
  }
  const onAddAddress = () => {
    setSelectedAddressId(null)
    addressModal.onOpen()
  }

  return (
    <Box display="flex" flexDirection={'column'} gap={'16px'} data-cs-mask="">
      <Stack position="relative" paddingLeft="20px" data-cs-mask="">
        <LocationIcon
          position="absolute"
          style={{top: '-2px', left: '-6px'}}
          width="20px"
          height="20px"
        />
        <Stack spacing="4px" data-cs-mask="">
          <Stack display={'flex'} flexDirection={'row'}>
            {title && (
              <Text lineHeight="shorter" variant="text4" data-cs-mask="">
                {capitalize(title)}
              </Text>
            )}
            {fullName && (
              <Text lineHeight="shorter" variant="text4" data-cs-mask="" data-test-selector="user-full-name">
                {fullName}
              </Text>
            )}
          </Stack>
          <Text lineHeight="shorter" variant="text4" data-cs-mask="" data-test-selector="delivery-address-summary">
            {displayAddress()}
          </Text>
        </Stack>
        {!preBook && (
          <Flex gap="8px">
            <Button
              variant="link"
              onClick={() => onEditAddress(addressId)}
              textDecoration="underline"
              data-test-selector="edit-address-title"
              style={{width: 'fit-content', height: 'fit-content'}}
            >
              Edit this address
            </Button>
              <>
                <Box borderLeft="1px" borderColor="gray200" marginX="2px" height="20px" />
                <Button
                  variant="link"
                  onClick={() => onAddAddress()}
                  textDecoration="underline"
                  data-test-selector="add-new-address"
                  style={{width: 'fit-content', height: 'fit-content'}}
                >
                  Add new address
                </Button>
              </>
          </Flex>
        )}
      </Stack>

      <Stack gridColumn={'1'} paddingLeft="20px" position="relative" data-cs-mask="" width={'full'}>
        <PhoneIcon
          position="absolute"
          style={{top: '-2px', left: '-6px', color: '#bebebe'}}
          width="20px"
          height="20px"
        />
        <Text lineHeight="shorter" variant="text4" data-cs-mask="">
          {phone || ''}
        </Text>
        {!preBook && (
          <Button
            variant="link"
            onClick={() => onEditAddress(addressId)}
            textDecoration="underline"
            data-test-selector="change-phone-number"
            style={{width: 'fit-content', height: 'fit-content'}}
          >
            Change this number
          </Button>
        )}
      </Stack>
      <AddOrEditCustomerAddressModal
        addressId={selectedAddressId}
        onSubmitAddressModalForm={onSubmitAddressModalForm}
        onDismissAddressModalForm={onDismissAddressModalForm}
        {...addressModal}
      />
    </Box>
  )
})
